import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { LgvUserService, NotificationService } from '../../core/core.module';
import { GreaterThanZero } from '../../core/utility/lgv-form-validator';
import { LgvModel } from '../../data-models/longevity.model';
import { environment as env } from '../../../environments/environment';

@Component({
    selector: 'lgv-pricing-preferences-modal',
    templateUrl: './pricing-preferences-modal.component.html',
    styleUrls: ['./pricing-preferences-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PricingPreferencesModalComponent implements OnInit, OnDestroy {

    isLoading$ = new BehaviorSubject(false);
    onDestroy$ = new Subject();
    pricingPreferencesForm: UntypedFormGroup;
    userIdParam: string = null;
    pricingProviderSettings: LgvModel.PricingProviderSettings = null;
    agentInfoParam: LgvModel.Agent = null;

    constructor(
        private http: HttpClient,
        private fb: UntypedFormBuilder,
        public lgvUserSvc: LgvUserService,
        private notificationSvc: NotificationService,
        public dialogRef: MatDialogRef<PricingPreferencesModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        if (this.data.agentInfo) {
            this.userIdParam = this.data.agentInfo.id;
            this.agentInfoParam = this.data.agentInfo;
        }
    }

    ngOnInit(): void {

        this.initializeForm();

        this.lgvUserSvc.fetchPricingSettings(this.userIdParam).pipe(takeUntil(this.onDestroy$)).subscribe(x => {
            if (x) {
                this.pricingProviderSettings = x
                if (!!this.pricingProviderSettings?.targetPrice) {
                    this.pricingPreferencesForm.controls.targetPrice.setValue(+this.pricingProviderSettings.targetPrice);
                }
                if (!!this.pricingProviderSettings?.maxFee) {
                    this.pricingPreferencesForm.controls.maxFee.setValue(+this.pricingProviderSettings.maxFee);
                }
            }

        });
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }


    initializeForm() {

        this.pricingPreferencesForm = this.fb.group({
            targetPrice: [100, [Validators.required, GreaterThanZero()]],
            maxFee: [0, [Validators.required]],
        });

    }

    onSubmit() {
        if (!this.pricingPreferencesForm.valid) {
            return;
        }

        let model = this.pricingPreferencesForm.getRawValue();

        // We need the values below to be set since there are required for user patch endpoint
        model.firstName = this.agentInfoParam.firstName;
        model.lastName = this.agentInfoParam.lastName;
        model.jobTitle = this.agentInfoParam.jobTitle;

        let bldUrl = `${env.LgvApiBaseUrl}/users/${this.agentInfoParam.id}`;
        this.http.patch<any>(bldUrl, model).pipe(takeUntil(this.onDestroy$)).subscribe(x => {
            this.isLoading$.next(false);
            this.notificationSvc.success('Pricing preferences have been saved');

            if (this.lgvUserSvc.IsImpersonatingAgent) {
                this.lgvUserSvc.ImpersonateAgent(this.agentInfoParam.id, true);
            }
            else {
                this.lgvUserSvc.LoadDBUserSS(false);
            }

            this.dialogRef.close({ action: true });
        },
            (err) => {
                this.isLoading$.next(false);
                this.notificationSvc.error('There was an error updating the pricing preferences');
                console.log('Error:');
                console.log(err);
            }
        );
    }

    onCancel() {
        this.dialogRef.close({ action: false });
    }
}
